import React from 'react';
import style from "./style.module.scss"
import {Link} from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next'; // Import useTranslation
import {useAnimationConfig} from "../../../hooks/useAnimationConfig";
import { useSelector } from 'react-redux';

const WrapperContent = ({ children, displayCreateBtn = true, bg = false  }) => {
  const { t } = useTranslation(); // Instantiate the hook
  const { routeVariants} = useAnimationConfig()
  const {user} = useSelector(state => state);

  const effectiveDisplayCreateBtn = user.type === "Expeditor" ? false : displayCreateBtn;

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      className={style.orders}
      style={bg ? { backgroundColor: '#eee' } : {}}
    >
      { children }
      { effectiveDisplayCreateBtn && (
        <div className={style.mobile_flex}>
          <Link to={"/orders/create"} className={style.mobile_order_btn}>
            <span className={style.mobile_create_btn}>{t('header.button.createNewOrder')}</span>
          </Link>
        </div>
      )}
    </motion.div>
  );
};

export default WrapperContent;
